import toastManager from "../toastManager";

export const validateSave = ({
  calculationProgress,
  hasDataChanged,
  computeRequired,
}) => {
  const dataChanged = hasDataChanged();

  const calculationState = calculationProgress.state;

  // Cannot save while a calculation has not started, is happening, or if it has failed.
  if (
    calculationState === "NOT STARTED" ||
    calculationState === "PENDING" ||
    calculationState === "PROGRESS" ||
    calculationState === "FAILURE"
  ) {
    toastManager(
      "warning",
      "Can't save yet!",
      "Entry calculation needs to be completed before it can be saved."
    );
    return false;
  }
  // There is no need too save the entry if no changes have been made.
  else if (!dataChanged) {
    toastManager(
      "warning",
      "No Changes Made",
      "The entry is already saved, as no changes have been made."
    );
    return false;
  }
  // Check if entry needs to be re- computed. Cannot save before it is calculated.
  else if (computeRequired) {
    toastManager(
      "warning",
      "Re-calculation Required",
      "Entry needs to be re-calculated due to image changes before it can be saved."
    );
    return false;
  }

  // If there is nothing prohibiting a save, return true to allow save
  return true;
};
